<template>

    <h3>{{getInterfaceText('title_complete_your_rider_experience')}}</h3>

    <div id="related-items-scroller" class="horizontal-scroller" :class="rpDown ? 'grabbing' : ''" @mousedown="mouseDown">
        <div class="items-container">
            <div v-for="item in Cart.RelatedProducts" :key="item.Id" class="item">
                <a :href="item.URL" class="item-link track-GA4-event" data-ga4_name="select_item" data-ga4_item_list_name="complete your rider experience" data-ga4_location="mini cart" :data-ga4_items="GA4Items(item)"></a>
                <div class="inner">
                    <picture>
                        <!--<source media="(max-width: 768px)" srcset="@item.ImageMobile">-->
                        <img :src="item.Image">
                    </picture>
                    <div class="text">
                        <!--<p class="bestfor">
                            @item.BestForLabel: <span class="bestforvalue">@item.BestForValue</span>
                        </p>-->
                        <p class="model">{{item.Name}}</p> 
                        <p class="price">
                            <span class="newprice" :class="{ 'omnibus-mode': Cart.EnableLowest30DaysPriceMode == true && item.PriceScenario == 1 }">{{item.PriceToFormat}}</span>
                            <span v-if="Cart.EnableLowest30DaysPriceMode == false && item.PriceOriginalToFormat != null && item.PriceOriginalToFormat.length > 0 && item.PriceOriginalToFormat != item.PriceToFormat">
                                <span class="sr-only">Original price: </span>
                                <span class="oldprice">{{item.PriceOriginalToFormat}}</span>
                            </span>
                            <span v-if="Cart.EnableLowest30DaysPriceMode == true && item.PriceScenario == 1">
                                <span class="sr-only">Original price: </span>
                                <span class="oldprice omnibus-mode">{{item.PriceLowest30ToFormat}}</span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>


    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    //import ref from 'vue';

    //const myDiv = ref <HTMLDivElement | null> (null);

    export default {
        name: 'RelatedProducts',
        mixins: [cartMixin, generalMixin],
        template: '#related-products-template',
        data: function () {
            return {
                rpX: null,
                rpLeft: null,
                rpDown: null,
                show: false
            }
        },
        methods: {
            mouseDown(e) {
                e.preventDefault();
                // get element
                var myScroller = document.getElementById('related-items-scroller');
                // down?
                this.rpDown = true;
                // position of click within scroller
                this.rpX = e.pageX;
                // left position of scroller at start of click
                this.rpLeft = myScroller.scrollLeft;
            },
            mouseMove(e) {
                if (this.rpDown) {
                    var newX = e.pageX;
                    Window.handleScrollerMouseMove(this.rpLeft, newX, this.rpX);
                }
            },
            mouseUp() {
                this.rpDown = false;
                Window.handleScrollerMouseUp();
            },
            GA4Items(item) {
                let items = [];
                if (item != null) {
                    items.push(item);
                } else {
                    items = this.Cart.RelatedProducts;
                }

                let result = [];
                for (let item of items) {
                    let newItem = {
                        item_id: 'gearproduct-' + item.Id,
                        item_name: item.Name,
                        index: item.Index,
                        item_brand: item.Brand,
                        item_category: item.Category,
                        item_category2: item.Category2,
                        item_category3: item.Category3,
                        price: item.Price,
                        discount: item.Discount,
                        quantity: 1
                    }
                    result.push(newItem);
                }

                return JSON.stringify(result, null, 2);

            }
        },
        computed: {

        },
        created() {
            // track mouse for whole body
            document.addEventListener('mousemove', this.mouseMove);

            // track mouse up for whole body
            document.addEventListener('mouseup', this.mouseUp);

            // add interfacetexts
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
